/**
 * Behavior Engine - camada de inteligência sobre o Core.
 * Estado agregado (scroll, click, idle, exit intent) + engagement + eventos USER_IDLE, EXIT_INTENT, BEHAVIOR_SUMMARY.
 */

export {
  initBehaviorEngine,
  getBehaviorState,
  enqueueBehaviorSnapshot,
  resetForNewPage,
  resetBehaviorState,
  destroyBehaviorEngine,
  getBehaviorBufferStatsExport,
} from './aggregator';

export { computeEngagement } from './engagement';
export type { EngagementOptions } from './engagement';

export { getElementFingerprint } from './click';
export { initScrollBehavior, getScrollState, resetScrollState } from './scroll';
export { initClickBehavior, getClickState, resetClickState } from './click';
export { initIdleBehavior, getIdleState, resetIdleState } from './idle';
export {
  initExitIntentBehavior,
  getExitIntentFired,
  resetExitIntentState,
} from './exitIntent';
export {
  initVisibilityBehavior,
  getVisibilityState,
  resetVisibilityState,
} from './visibility';
export {
  initViewportBehavior,
  getViewportState,
  destroyViewportBehavior,
} from './viewport';

export {
  getBehaviorStateMachine,
  resetBehaviorStateMachine,
} from './stateMachine';
export {
  getBehaviorBatchPayload,
  getBehaviorBufferStats,
  clearBehaviorBuffer,
} from './buffer';

export { BehaviorPhase } from './types';
export type {
  BehaviorState,
  BehaviorEngineConfig,
  ScrollState,
  ClickState,
  IdleState,
  VisibilityState,
  EngagementLevel,
  EngagementResult,
  ViewportConfig,
  ViewportSelectorType,
  BehaviorSnapshot,
  BehaviorCriticalEvent,
  BehaviorCriticalEventType,
  BehaviorBatchPayload,
} from './types';
